module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"journey":"Reise","steps":"Steg","members":"Medlemmer","completed":"Fullført"},"en":{"journey":"Journey","steps":"Steps","members":"Members","completed":"Completed"}}')
  delete Component.options._Ctor
}
